// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/all-images/slider-imgs/slider-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/all-images/slider-imgs/slider-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/all-images/slider-imgs/slider-3.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slider__item {
    max-width: 100%;
    height: 650px;
}
.slider__item-01 {
    background: linear-gradient(rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.slider__item-02 {
    background: linear-gradient(rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5)), url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.slider__item-03 {
    background: linear-gradient(rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5)), url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.hero__slider {
    overflow: hidden;
}
.slider__content {
    padding-top: 150px;
}
.slider__content h1 {
    font-size: 3.2rem;
    font-weight: 700;
}
.reserve__btn {
    background: #fff!important;
    color: #03A5D5;
    border: none;
    outline: none;
}
.reserve__btn a {
    text-decoration: none;
    font-weight: 600;
    transition: 0.3s;
}
.reserve__btn a:hover {
    color: #FF7F50;
}
@media only screen and (max-width:992px) {
    .slider__item {
        height: 530px;
        width: 100%;
    }
    .slider__content {
        margin-top: -70px;
    }
    .slider__content h1 {
        font-size: 2rem;
    }
}
@media only screen and (max-width:768px) {
    .slider__item {
        height: 450px;
    }
    .slider__content h1 {
        font-size: 1.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/hero-slider.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,sIAAmJ;IACnJ,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,sIAAmJ;IACnJ,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,sIAAmJ;IACnJ,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,0BAA0B;IAC1B,cAAc;IACd,YAAY;IACZ,aAAa;AACjB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI;QACI,aAAa;QACb,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".slider__item {\n    max-width: 100%;\n    height: 650px;\n}\n.slider__item-01 {\n    background: linear-gradient(rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5)), url('../assets/all-images/slider-imgs/slider-1.jpg');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.slider__item-02 {\n    background: linear-gradient(rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5)), url('../assets/all-images/slider-imgs/slider-2.jpg');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.slider__item-03 {\n    background: linear-gradient(rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5), rgb(0, 13, 107, 0.5)), url('../assets/all-images/slider-imgs/slider-3.jpg');\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n}\n.hero__slider {\n    overflow: hidden;\n}\n.slider__content {\n    padding-top: 150px;\n}\n.slider__content h1 {\n    font-size: 3.2rem;\n    font-weight: 700;\n}\n.reserve__btn {\n    background: #fff!important;\n    color: #03A5D5;\n    border: none;\n    outline: none;\n}\n.reserve__btn a {\n    text-decoration: none;\n    font-weight: 600;\n    transition: 0.3s;\n}\n.reserve__btn a:hover {\n    color: #FF7F50;\n}\n@media only screen and (max-width:992px) {\n    .slider__item {\n        height: 530px;\n        width: 100%;\n    }\n    .slider__content {\n        margin-top: -70px;\n    }\n    .slider__content h1 {\n        font-size: 2rem;\n    }\n}\n@media only screen and (max-width:768px) {\n    .slider__item {\n        height: 450px;\n    }\n    .slider__content h1 {\n        font-size: 1.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
